<div [tiimeTooltip]="tiimeBusinessProAccountIntention | codeAndLabel: tiimeBusinessProAccountIntentions()">
  @switch (tiimeBusinessProAccountIntention) {
    @case (TiimeBusinessProAccountIntention.interested) {
      <mat-icon class="success" fontSet="fontastic" fontIcon="icon-ic-check"></mat-icon>
    }
    @case (TiimeBusinessProAccountIntention.notInterested) {
      <mat-icon class="error" fontSet="fontastic" fontIcon="icon-ic-close"></mat-icon>
    }
    @case (TiimeBusinessProAccountIntention.undecided) {
      <mat-icon class="neutral" svgIcon="icon-question-mark"></mat-icon>
    }
  }
</div>
